import { combineReducers } from 'redux';

import delegation from './delegationReducer';

const rootReducer = combineReducers({
  delegation,
});

export default rootReducer;
